module.exports = __webpack_public_path__ + "static/coming-soon-fde62702b8e7a0cf11edc439167ac07d.png";